import { useNavigate } from 'react-router-dom';

export default function Settings() {
  const navigate = useNavigate();
  const platforms = [
    { name: 'Amazon SP-API', keys: ['AMAZON_CLIENT_ID', 'AMAZON_CLIENT_SECRET', 'AMAZON_REFRESH_TOKEN', 'AMAZON_MARKETPLACE_ID'], docs: 'https://developer-docs.amazon.com/sp-api/' },
    { name: 'eBay API', keys: ['EBAY_CLIENT_ID', 'EBAY_CLIENT_SECRET', 'EBAY_REFRESH_TOKEN'], docs: 'https://developer.ebay.com/' },
    { name: 'Shopify', keys: ['SHOPIFY_STORE_URL', 'SHOPIFY_ACCESS_TOKEN'], docs: 'https://shopify.dev/docs/api/admin-rest' },
    { name: 'BigCommerce', keys: ['BIGCOMMERCE_STORE_HASH', 'BIGCOMMERCE_ACCESS_TOKEN', 'BIGCOMMERCE_CLIENT_ID'], docs: 'https://developer.bigcommerce.com/' },
  ];

  const s = {
    page: { padding: 32, fontFamily: 'system-ui, sans-serif', maxWidth: 700, margin: '0 auto' },
    back: { padding: '8px 14px', background: '#f0f0f0', color: '#555', border: 'none', borderRadius: 8, fontSize: 13, cursor: 'pointer', marginBottom: 24 },
    title: { fontSize: 20, fontWeight: 600, marginBottom: 8 },
    sub: { fontSize: 13, color: '#888', marginBottom: 28 },
    card: { background: '#fff', borderRadius: 10, padding: '20px 24px', marginBottom: 16, border: '1px solid #eee' },
    cardTitle: { fontSize: 15, fontWeight: 600, marginBottom: 4 },
    keyList: { marginTop: 10 },
    key: { fontFamily: 'monospace', fontSize: 12, color: '#534AB7', background: '#f5f4ff', padding: '3px 8px', borderRadius: 5, display: 'inline-block', margin: '3px 4px 3px 0' },
    docsLink: { fontSize: 12, color: '#534AB7', textDecoration: 'none', display: 'inline-block', marginTop: 8 },
    note: { background: '#FAEEDA', borderRadius: 10, padding: '16px 20px', fontSize: 13, color: '#633806', marginBottom: 24 },
  };

  return (
    <div style={s.page}>
      <button style={s.back} onClick={() => navigate('/')}>← Back</button>
      <div style={s.title}>Settings</div>
      <p style={s.sub}>API credentials are configured in the <code>.env</code> file on your server. Restart PM2 after any changes.</p>

      <div style={s.note}>
        ⚠️ To update credentials: SSH into your server → edit <code>/home/selldesk/shopboard/backend/.env</code> → run <code>pm2 restart shopboard</code>
      </div>

      {platforms.map(p => (
        <div key={p.name} style={s.card}>
          <div style={s.cardTitle}>{p.name}</div>
          <div style={s.keyList}>
            {p.keys.map(k => <span key={k} style={s.key}>{k}</span>)}
          </div>
          <a style={s.docsLink} href={p.docs} target="_blank" rel="noreferrer">→ Developer docs</a>
        </div>
      ))}
    </div>
  );
}
